module.exports = __webpack_public_path__ + "static/img/jigou-wuhanguanggu-top.9f4343f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-wuhanguanggu-top.png
// module id = ONSF
// module chunks = 2